import PropTypes from 'prop-types'
import { memo } from 'react'
import BG from 'components/core/BG/BG'
import Divider from 'components/core/Divider/Divider'
import TransitionSwap from 'components/elements/TransitionSwap/TransitionSwap'
import { useModalContext } from '../../provider/ModalProvider'
import styles from './Header.module.scss'

/**
 * The `Header`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Header (props) {
  const { children, className } = props
  const { isModalContentActive: isActive } = useModalContext()

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <BG color="a" opacity="a" mask="wide" />
        <Divider mask="wide" />
        <div className={styles.headerDisplay}>
          <TransitionSwap
            className={styles.headerInner}
            delayShow={0.2}
            delayHide={0.2}
            classNameContent={className}
          >
            {isActive ? children : ''}
          </TransitionSwap>
        </div>
        <Divider mask="wide" />
      </div>
    </div>
  )
}

/** @type {object} */
Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

/** @type {object} */
Header.defaultProps = {
  className: '',
  children: []
}

// Memoize
export default memo(Header)
